import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { convertToError } from '@atlaskit/frontend-utilities/convert-to-error';
import { useLinkPickerAnalytics } from '../../common/analytics';
import { ANALYTICS_CHANNEL, RECENT_SEARCH_LIST_SIZE } from '../../common/constants';
import createEventPayload from '../../common/utils/analytics/analytics.codegen';
import { usePluginReducer } from './reducer';
import { CancellationError, resolvePluginUpdates } from './utils';
export function usePlugins(state, activeTab, plugins) {
  var _activePlugin$tabKey;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    retries = _useState2[0],
    setRetries = _useState2[1];
  var _usePluginReducer = usePluginReducer(),
    _usePluginReducer2 = _slicedToArray(_usePluginReducer, 2),
    pluginState = _usePluginReducer2[0],
    dispatch = _usePluginReducer2[1];
  var _useLinkPickerAnalyti = useLinkPickerAnalytics(),
    trackAttribute = _useLinkPickerAnalyti.trackAttribute;
  var activePlugin = plugins === null || plugins === void 0 ? void 0 : plugins[activeTab];
  trackAttribute('tab', (_activePlugin$tabKey = activePlugin === null || activePlugin === void 0 ? void 0 : activePlugin.tabKey) !== null && _activePlugin$tabKey !== void 0 ? _activePlugin$tabKey : null);

  // This useEffect block must be called before any other to ensure onActivation is fired at before resolve
  useEffect(function () {
    if (activePlugin && activePlugin.UNSAFE_onActivation) {
      activePlugin.UNSAFE_onActivation();
    }
  }, [activePlugin]);
  useEffect(function () {
    if (!activePlugin) {
      return;
    }
    if (!state) {
      dispatch({
        type: 'CLEAR'
      });
      return;
    }
    dispatch({
      type: 'LOADING'
    });
    var _resolvePluginUpdates = resolvePluginUpdates(activePlugin, state),
      next = _resolvePluginUpdates.next,
      cancel = _resolvePluginUpdates.cancel;
    var updateResults = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _isLoading, _yield$next, value, done;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _isLoading = true;
            case 2:
              if (!_isLoading) {
                _context.next = 12;
                break;
              }
              _context.next = 5;
              return next();
            case 5:
              _yield$next = _context.sent;
              value = _yield$next.value;
              done = _yield$next.done;
              _isLoading = !done;
              dispatch({
                type: 'SUCCESS',
                payload: {
                  items: limit(value.data),
                  isLoading: !done
                }
              });
              _context.next = 2;
              break;
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              if (!(_context.t0 instanceof CancellationError)) {
                dispatch({
                  type: 'ERROR',
                  payload: _context.t0
                });
                createAnalyticsEvent(createEventPayload('operational.resultsResolve.failed', {
                  error: convertToError(_context.t0).toString()
                })).fire(ANALYTICS_CHANNEL);
              }
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }));
      return function updateResults() {
        return _ref.apply(this, arguments);
      };
    }();
    updateResults();
    return cancel;
  }, [activePlugin, state, retries, createAnalyticsEvent, dispatch]);
  var tabs = useMemo(function () {
    if (!plugins || plugins.length <= 1) {
      return [];
    }
    return plugins.filter(function (plugin) {
      return !!plugin.tabTitle;
    }).map(function (plugin) {
      return {
        tabTitle: plugin.tabTitle
      };
    });
  }, [plugins]);
  var handleRetry = useCallback(function () {
    setRetries(function (prev) {
      return ++prev;
    });
  }, []);
  var items = pluginState.items,
    isLoading = pluginState.isLoading,
    error = pluginState.error;
  return {
    tabs: tabs,
    items: items,
    isLoading: isLoading,
    activePlugin: activePlugin,
    isActivePlugin: !!activePlugin,
    error: error,
    retry: handleRetry,
    errorFallback: activePlugin === null || activePlugin === void 0 ? void 0 : activePlugin.errorFallback,
    pluginAction: activePlugin === null || activePlugin === void 0 ? void 0 : activePlugin.action
  };
}
function limit(items) {
  return items.slice(0, RECENT_SEARCH_LIST_SIZE);
}